import React, { useState } from 'react';
import { ContactPopup } from './ContactPopup';
export function Footer() {
  const [isContactOpen, setIsContactOpen] = useState(false);
  return <footer className="bg-[#1B5E20] text-white py-12" data-id="element-41">
      <ContactPopup isOpen={isContactOpen} onClose={() => setIsContactOpen(false)} data-id="element-42" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-43">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-44">
          <div data-id="element-45">
            <div className="flex items-center space-x-2 mb-4" data-id="element-46">
              <img src="https://cdn.magicpatterns.com/uploads/wvCpgEAasUkNkK1QxxXNi9/LymphoriaX_(1).png" alt="LymphoriaX Logo" className="h-8" data-id="element-47" />
            </div>
            <p className="text-gray-300 max-w-sm" data-id="element-48">
              Premium herbal support for lymphatic drainage, energy, and
              vitality. Trusted by 12,847+ women.
            </p>
          </div>
          <div className="flex flex-col md:items-end justify-center" data-id="element-49">
            <div className="space-x-6 text-gray-300 text-sm" data-id="element-50">
              <a href="#" className="hover:text-[#10B981] transition-colors" data-id="element-51">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-[#10B981] transition-colors" data-id="element-52">
                Terms of Service
              </a>
              <button onClick={() => setIsContactOpen(true)} className="hover:text-[#10B981] transition-colors" data-id="element-53">
                Contact Us
              </button>
            </div>
          </div>
        </div>

        <div className="border-t border-[#10B981]/30 pt-8 text-center md:text-left" data-id="element-54">
          <p className="text-xs text-gray-400 leading-relaxed max-w-4xl" data-id="element-55">
            * These statements have not been evaluated by the FDA. This product
            is not intended to diagnose, treat, cure, or prevent any disease.
            Results may vary. The information provided does not constitute
            medical advice and should not take the place of consulting a
            physician. This information does not and should not replace
            treatment from a medical professional.
          </p>
          <p className="text-xs text-gray-400 mt-4" data-id="element-56">
            © {new Date().getFullYear()} LymphoriaX. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}